import { Component, OnInit }          from '@angular/core';
import { ActivatedRoute }             from '@angular/router';

import { UserService }                from '../dashboard/program-list/user.service';
import { ProgramService }             from '../shared/services/program.service';
import { SubscriptionsService }       from './subscriptions.service';

import { SubscriptionTeam }           from './models/subscription-team';
import { Program }                    from '../models/program/program';
import { GroupListItem }              from '../models/program/group-list-item';

import { PermissionsService }         from '../shared/services/permissions.service';
import { AllPermissions }             from '../models/permissions';


@Component({
  selector: 'app-subscription-teams',
  templateUrl: './subscription-teams.component.html',
  styleUrls: ['./subscription-teams.component.less']
})
export class SubscriptionTeamsComponent implements OnInit {
  private _subscriptionId: number = null;
  public teams: SubscriptionTeam[] = null;
  public selectedTeam: SubscriptionTeam = null;
  public showRemoveTeam: boolean = false;
  public showAddTeam: boolean = false;
  public programs: Program[] = null;
  public program: Program = null;
  public teamToAdd: GroupListItem = null;
  public addingTeam: boolean = false;

  constructor(private api: SubscriptionsService, private route: ActivatedRoute, private programService: ProgramService) {
    this.route.parent.params.subscribe(params => {
      this._subscriptionId = params['id'];
      this.loadData();
      this.programService.getPrograms().subscribe(programs => this.programs = programs);
    });
  }

  private loadData() {
    this.teams = null;
    this.api.getSubscriptionTeams(this._subscriptionId).subscribe(teams => this.teams = teams);
  }

  ngOnInit() {
  }

  public openRemoveTeam(team: any) {
    this.selectedTeam = team;
    this.showRemoveTeam = true;
  }

  public removeSelectedTeam() {
    this.api.removeSubscriptionTeam(this._subscriptionId, this.selectedTeam.id).subscribe(() => {
      this.teams.splice(this.teams.indexOf(this.selectedTeam), 1);
      this.showRemoveTeam = false;
    });
  }

  public linkTeam() {
    this.addingTeam = true;
    this.api.addSubscriptionTeam(this._subscriptionId, this.teamToAdd.id).subscribe(() => {
      this.addingTeam = false;
      this.showAddTeam = false;
      this.program = null;
      this.teamToAdd = null;
      this.loadData();
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscription-teams.component.ts